// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestOrder_modal__img__gS6EC {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.RequestOrder_main_nav__G--NR {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 1rem;
  background-color: var(--color-dark-2);
  box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);
  color: var(--color-white);
}
.RequestOrder_main_nav__G--NR > :not(:last-child) {
  margin-right: 6rem;
}
.RequestOrder_main_nav_group__YcnaT {
  position: relative;
}
.RequestOrder_main_nav_more__IaXJN {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-dark-2);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.RequestOrder_main_nav_more__IaXJN > :not(last-child) {
  margin-bottom: 1rem;
}
.RequestOrder_main_nav_item__9Yl7X {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.RequestOrder_main_nav_item__9Yl7X:hover, .RequestOrder_main_nav_item__9Yl7X:focus, .RequestOrder_main_nav_item__9Yl7X:focus-visible, .RequestOrder_main_nav_item__9Yl7X:focus-within {
  font-weight: 700;
  color: var(--color-white);
  border-bottom: solid 2px var(--color-white);
}
.RequestOrder_main_nav_item_active__5N3gW {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.RequestOrder_main_nav_item_active__5N3gW:hover, .RequestOrder_main_nav_item_active__5N3gW:focus, .RequestOrder_main_nav_item_active__5N3gW:focus-visible, .RequestOrder_main_nav_item_active__5N3gW:focus-within {
  font-weight: 700;
  color: var(--color-primary-3);
  border-bottom: solid 2px var(--color-primary-3);
}
.RequestOrder_main__content__sNgnF {
  margin-top: 5rem;
}
.RequestOrder_main__metrics__lVS9B {
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .RequestOrder_main__metrics__lVS9B {
    grid-template-columns: repeat(2, 50%);
  }
}
.RequestOrder_main__metrics_active__609dZ {
  background-color: var(--color-green);
  color: var(--color-white);
}
.RequestOrder_main__metrics_suspended__UIuQE {
  background-color: var(--color-yellow);
}
.RequestOrder_main__metrics_terminated__psUvd {
  background-color: var(--color-error);
  color: var(--color-white);
}
.RequestOrder_main__center__mVL4A {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.RequestOrder_createLinks__4WKhX {
  display: flex;
  justify-content: center;
}
.RequestOrder_createLinks_1__pWGxP {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 60%;
}
@media only screen and (max-width: 50em) {
  .RequestOrder_createLinks_1__pWGxP {
    width: 100%;
  }
}
.RequestOrder_createLinks_2__z0FxM {
  background-color: var(--color-dark-2);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.RequestOrder_createLinks_2__z0FxM img {
  width: 7rem;
}
.RequestOrder_createLinks_mini__mY5hw {
  background-color: var(--color-white);
  padding: 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.RequestOrder_beside__9uhqO {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .RequestOrder_beside__9uhqO {
    grid-template-columns: 100%;
  }
}

.RequestOrder_status__pending__30k1M {
  color: var(--color-yellow-3);
}
.RequestOrder_status__paid__a61e3 {
  color: var(--color-green);
}
.RequestOrder_status__failed__rmzGV {
  color: var(--color-error);
}

.RequestOrder_active__Ztilb {
  font-weight: 700;
  color: var(--color-green);
}

.RequestOrder_deactivated__IBWd6 {
  font-weight: 700;
  color: var(--color-error);
}

.RequestOrder_imagePreviewContainer__wXRXD {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.RequestOrder_imgContainer__31DMg {
  position: relative;
  width: 150px;
  height: 150px;
  margin-top: 2rem;
}
.RequestOrder_imgContainer_imageUpload__5VlIo {
  background-size: contain;
  width: 100%;
  height: 100%;
}

.RequestOrder_cancel__BCrIf {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-weight: 700;
  top: 0;
  right: 0;
  background-color: var(--color-error);
  color: var(--color-white);
  border: none;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/RequestOrder/RequestOrder.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,qCAAA;EACA,gDAAA;EACA,yBAAA;AALF;AASE;EACC,kBAAA;AAPH;AAUE;EACC,kBAAA;AARH;AAWE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AATH;AAWG;EACC,mBAAA;AATJ;AAaE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAXH;AAiBG;EAIC,gBAAA;EACA,yBAAA;EACA,2CAAA;AAlBJ;AAqBG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,6BAAA;EACA,+CAAA;AAnBJ;AAyBI;EAIC,gBAAA;EACA,6BAAA;EACA,+CAAA;AA1BL;AAgCC;EACC,gBAAA;AA9BF;AAiCC;EAEC,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AA/BF;AAiCE;EATD;IAUE,qCAAA;EA9BD;AACF;AAgCE;EACC,oCAAA;EACA,yBAAA;AA9BH;AAiCE;EACC,qCAAA;AA/BH;AAkCE;EACC,oCAAA;EACA,yBAAA;AAhCH;AAoCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCF;;AAsCA;EACC,aAAA;EACA,uBAAA;AAnCD;AAqCC;EACC,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EAEA,UAAA;AApCF;AAsCE;EARD;IASE,WAAA;EAnCD;AACF;AAsCC;EACC,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApCF;AAsCE;EACC,WAAA;AApCH;AAwCC;EACC,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,WAAA;AAtCF;;AA0CA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAvCD;AAyCC;EAND;IAOE,2BAAA;EAtCA;AACF;;AA0CC;EACC,4BAAA;AAvCF;AA0CC;EACC,yBAAA;AAxCF;AA2CC;EACC,yBAAA;AAzCF;;AA6CA;EACC,gBAAA;EACA,yBAAA;AA1CD;;AA6CA;EACC,gBAAA;EACA,yBAAA;AA1CD;;AA6CA;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AA1CD;;AA6CA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA1CD;AA4CC;EACC,wBAAA;EACA,WAAA;EACA,YAAA;AA1CF;;AA6CA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,QAAA;EACA,oCAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1CD","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 1rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-dark-2);\n\t\tbox-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);\n\t\tcolor: var(--color-white);\n\t\t// border-bottom: solid 1px var(--color-dark);\n\t\t// border-radius: 1rem 1rem 0 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 6rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-dark-2);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tborder-bottom: solid 2px var(--color-white);\n\t\t\t}\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary-3);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary-3);\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \twidth: 47%;\n\t\t\t\t// }\n\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&:focus-visible,\n\t\t\t\t&:focus-within {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: var(--color-primary-3);\n\t\t\t\t\tborder-bottom: solid 2px var(--color-primary-3);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&__content {\n\t\tmargin-top: 5rem;\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 50%);\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_suspended {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_terminated {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t&__center {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.createLinks {\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t&_1 {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t\twidth: 60%;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&_2 {\n\t\tbackground-color: var(--color-dark-2);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\timg {\n\t\t\twidth: 7rem;\n\t\t}\n\t}\n\n\t&_mini {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\twidth: 100%;\n\t}\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n.status {\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n.active {\n\tfont-weight: 700;\n\tcolor: var(--color-green);\n}\n\n.deactivated {\n\tfont-weight: 700;\n\tcolor: var(--color-error);\n}\n\n.imagePreviewContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-wrap: wrap;\n\tgap: 10px;\n}\n\n.imgContainer {\n\tposition: relative;\n\twidth: 150px;\n\theight: 150px;\n\tmargin-top: 2rem;\n\n\t&_imageUpload {\n\t\tbackground-size: contain;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n.cancel {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\tfont-weight: 700;\n\ttop: 0;\n\tright: 0;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tborder: none;\n\twidth: 2rem;\n\theight: 2rem;\n\tborder-radius: 50%;\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `RequestOrder_modal__img__gS6EC`,
	"main_nav": `RequestOrder_main_nav__G--NR`,
	"main_nav_group": `RequestOrder_main_nav_group__YcnaT`,
	"main_nav_more": `RequestOrder_main_nav_more__IaXJN`,
	"main_nav_item": `RequestOrder_main_nav_item__9Yl7X`,
	"main_nav_item_active": `RequestOrder_main_nav_item_active__5N3gW`,
	"main__content": `RequestOrder_main__content__sNgnF`,
	"main__metrics": `RequestOrder_main__metrics__lVS9B`,
	"main__metrics_active": `RequestOrder_main__metrics_active__609dZ`,
	"main__metrics_suspended": `RequestOrder_main__metrics_suspended__UIuQE`,
	"main__metrics_terminated": `RequestOrder_main__metrics_terminated__psUvd`,
	"main__center": `RequestOrder_main__center__mVL4A`,
	"createLinks": `RequestOrder_createLinks__4WKhX`,
	"createLinks_1": `RequestOrder_createLinks_1__pWGxP`,
	"createLinks_2": `RequestOrder_createLinks_2__z0FxM`,
	"createLinks_mini": `RequestOrder_createLinks_mini__mY5hw`,
	"beside": `RequestOrder_beside__9uhqO`,
	"status__pending": `RequestOrder_status__pending__30k1M`,
	"status__paid": `RequestOrder_status__paid__a61e3`,
	"status__failed": `RequestOrder_status__failed__rmzGV`,
	"active": `RequestOrder_active__Ztilb`,
	"deactivated": `RequestOrder_deactivated__IBWd6`,
	"imagePreviewContainer": `RequestOrder_imagePreviewContainer__wXRXD`,
	"imgContainer": `RequestOrder_imgContainer__31DMg`,
	"imgContainer_imageUpload": `RequestOrder_imgContainer_imageUpload__5VlIo`,
	"cancel": `RequestOrder_cancel__BCrIf`
};
export default ___CSS_LOADER_EXPORT___;
